module.exports = __webpack_public_path__ + "static/img/bitmap.db9c7da8.png";